module.exports = ".line {\n  border-left: 1px dashed #d81e06;\n  border-bottom: 1px dashed #d81e06; }\n"